import { StatusEnum } from "@gtpl/shared-models/common-models";
import { EntityRepository, Repository } from "typeorm";
import { SoInvoiceDetails } from "../sale-invoice-details.entity";

@EntityRepository(SoInvoiceDetails)
export class SoInvoiceRepository extends Repository<SoInvoiceDetails> {
    async getPoNumbers(){
        const soItemEntity =await this.createQueryBuilder("so_invoice_details")
            .select('so_invoice_details.po_number as poNumber,saleOrderInfo.status,saleOrderInfo.sale_order_id as saleOrderId')
            .leftJoin('so_invoice_details.saleOrderInfo', 'saleOrderInfo')
            .where(`saleOrderInfo.status in ('${StatusEnum.OPEN}','${StatusEnum.IN_PROGRESS}')`)
            .getRawMany();
            return soItemEntity;
    }

}
